import React from "react";
import "./style.scss";

const Loading = () => {
  return (
    <div className="circle-loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
export default Loading;
